import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import Choice, { Option } from '@components/choice/Choice'

// import useReducer from '@store/useReducer'

import { FormikHelpers, useFormik } from 'formik'

import useI18n from '@i18n/useI18n'

interface Values {
  accompagnementPrestataire: boolean
}

const Type = ({ form, onForm }: ControleFormProps) => {
  const i18n = useI18n()

  const init: Values = React.useMemo(
    () => ({ accompagnementPrestataire: form.accompagnementPrestataire }),
    [form.accompagnementPrestataire]
  )

  const onSubmit = (vals: Values, { setSubmitting }: FormikHelpers<Values>) => {
    onForm(vals).finally(() => setSubmitting(false))
  }

  const { values, setFieldValue, handleSubmit, dirty } = useFormik<Values>({
    enableReinitialize: true,
    initialValues: init,
    onSubmit,
  })

  React.useEffect(() => {
    if (dirty) {
      // sumbit on change
      handleSubmit()
    }
  }, [values])

  const options: Option[] = [
    { label: i18n.t(`screens.controles.form.type.SOLO`), value: false },
    { label: i18n.t(`screens.controles.form.type.PRESTA`), value: true },
  ]

  const option = options.find((o) => o.value === values.accompagnementPrestataire)

  return (
    <MainContainer>
      <Choice
        data={options}
        onItemSelected={(opt) => setFieldValue('accompagnementPrestataire', opt.value)}
        value={option}
        inline={false}
      />
    </MainContainer>
  )
}

export default Type

const MainContainer = styled(View)`
  margin: 0 20px;
  margin-top: ${(props) => (props.theme.breakpoint === 'phone' ? 0 : 75)}px;
  flex: 1;
`
